module.exports = __webpack_public_path__ + "img/td_v1.43944de.png";